import React, { useState, useEffect, useCallback, useRef } from 'react';

import { downloadFile, extractFileNameFromHeaders } from '../../../../util/DownloadUtil';

import { retrieveQueryPerStaffReport, downloadQueryPerStaffReport } from '../../../../services/ReportService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import './QueriesPerStaff.css';

export const QueriesPerStaff = ({
  facility,
  dates,
  resetFilters,
  context,
  setSpinnerText,
  showToaster,
  downloadEnabled,
}) => {
  const [heading, setHeading] = useState('');
  const [results, setResults] = useState([]);
  const [queryStatus, setQueryStatus] = useState({ label: 'All Queries per Staff', value: 'All Queries per Staff' });

  const queryStatusOptions = useRef([
    'All Queries per Staff',
    'Answered Queries per Staff',
    'Closed Queries per Staff',
    'Invalid Queries per Staff',
    'Open Queries per Staff',
    'Re-issued Queries per Staff',
  ]);

  const generateReport = useCallback(async () => {
    setSpinnerText('Generating Report');
    const [data, error] = await retrieveQueryPerStaffReport(context.username, queryStatus.value, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      if (data.responseStatus === 'Success') {
        setHeading(data.heading);
        setResults(
          data.queryPerStaffVOS.map((vo) => {
            const { staff, grandTotal, queryPerStudyVOS } = vo;

            const result = {
              staffMember: staff,
            };

            queryPerStudyVOS.forEach((vo) => {
              result[vo.studyName] = vo.total;
            });

            result.grandTotal = grandTotal;

            return result;
          })
        );
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster, facility, dates, queryStatus.value]);

  useEffect(() => {
    generateReport();
  }, [generateReport]);

  const handleDownloadExcelClick = async () => {
    setSpinnerText('Downloading Queries per Staff Report');
    const [data, headers, error] = await downloadQueryPerStaffReport(context.username, queryStatus.value, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      const name = extractFileNameFromHeaders(headers);
      downloadFile(data, name);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  };

  return (
    <section className="queries-per-staff-content">
      <div className="queries-per-staff-table">
        <h1 className="queries-per-staff-table-heading">{heading}</h1>
        <Table
          tableData={results}
          maxRowCount={7}
          hiddenColumns={[]}
          columnWidths={{ staffMember: '300px' }}
          dropdownOption={queryStatus}
          dropdownOptions={queryStatusOptions.current.map((option) => ({ label: option, value: option }))}
          onDropdownChange={setQueryStatus}
          searchEnabled
          filterEnabled
          horizontalScroll
          stickyFirstRow
        />
      </div>
      <div className="queries-per-staff-table-buttons">
        <SaveButton
          title="Reset Filters"
          onClick={resetFilters}
          color="white"
          textColor="#077187"
          border="1px solid #077187"
        />
        {downloadEnabled && (
          <SaveButton
            title="Download Excel"
            onClick={handleDownloadExcelClick}
            color="#077187"
            border="1px solid #077187"
          />
        )}
      </div>
    </section>
  );
};
